export var getPizarra = function getPizarra(state) {
  return state.pizarra;
};
export var getColorLapiz = function getColorLapiz(state) {
  return getPizarra(state).colorLapiz;
};
export var getGrosorLapiz = function getGrosorLapiz(state) {
  return getPizarra(state).grosorLapiz;
};
export var getColorMarcador = function getColorMarcador(state) {
  return getPizarra(state).colorMarcador;
};
export var getGrosorMarcador = function getGrosorMarcador(state) {
  return getPizarra(state).grosorMarcador;
};
export var getAlphaMarcador = function getAlphaMarcador(state) {
  return getPizarra(state).alphaMarcador;
};
export var getGrosorBorrador = function getGrosorBorrador(state) {
  return getPizarra(state).grosorBorrador;
};
export var getEditorActivo = function getEditorActivo(state) {
  return getPizarra(state).editorActivo;
};
export var getHerramienta = function getHerramienta(state) {
  return getPizarra(state).herramienta;
};
export var getDataURL = function getDataURL(state) {
  return getPizarra(state).dataURL;
};